import React from 'react';
import { portfolioData } from '../data/portfolioData';
import './TrendingNow.css';
import { FaCrown, FaRocket, FaBookOpen } from 'react-icons/fa';

const TrendingNow: React.FC = () => {
  const { trending } = portfolioData;

  const getCategoryIcon = (category: 'leadership' | 'project' | 'publication') => {
    switch (category) {
      case 'leadership':
        return <FaCrown className="category-icon" />;
      case 'project':
        return <FaRocket className="category-icon" />;
      case 'publication':
        return <FaBookOpen className="category-icon" />;
      default:
        return null;
    }
  };

  return (
    <div className="trending-section">
      <h2 className="trending-title">Now Trending</h2>
      <div className="trending-row">
        {trending.map((item, index) => (
          <div 
            key={index} 
            className="trending-card"
            onClick={() => item.link && window.open(item.link, '_blank')}
          >
            <div className="trending-image-container">
              <img src={item.image} alt={item.title} className="trending-image" />
              <div className="trending-overlay">
                <div className="trending-category">
                  {getCategoryIcon(item.category)}
                  <span>{item.category.charAt(0).toUpperCase() + item.category.slice(1)}</span>
                </div>
                <div className="trending-date">{item.date}</div>
              </div>
            </div>
            <div className="trending-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingNow; 